import React from 'react';
import { Dispatch } from 'redux';
import { connect } from "react-redux";
import { IApplicationState, RootActionCreators } from '../../../store';
import { createStyles, makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { RouteComponentProps } from 'react-router';
import { IReportDataObject } from '../../../entities/reports/IReportData';
import { IData as IOutreachDetail } from '../../../store/outreach/OutreachItem';
import { INaviagtions, mapNavigationsToProps, OutreachNavigation } from '../../organisms/outreach/OutreachNavigation';
import { PageHeader } from '../../organisms/PageHeader';
import { OutreachDetail } from '../../organisms/outreach/OutreachDetail';
import { FetchState } from '../../../entities/FetchState';
import { RefreshButton } from '../../atoms/buttons/RefreshButton';
import { EditButton } from '../../atoms/buttons/EditButton';
import { DeleteButton } from '../../atoms/buttons/DeleteButton';
import { useTranslation } from 'react-i18next';
import ErrorMessage from '../../organisms/ErrorMessage';


// CSS
const useStyles = makeStyles((theme: Theme) =>
    createStyles({}),
  ); 

interface IMatchParams {
    id: string;
}
interface IPropsFromParams extends RouteComponentProps<IMatchParams> { }

// Standard Properties from parent component
interface IProps { }

// Outgoing functions to parent component
interface IDispatch {}

// Properties from State 
interface IStateProps {
  details: IReportDataObject<IOutreachDetail>;
}
const mapStateProps = (state: IApplicationState): IStateProps => ({
    
    details: state.outreach.outreachItem.Item
});

// Outgoing functions to Dispatch
interface IDispatchProps {
    naviagations: INaviagtions;
    onLoadData: (id: string) => void;
    onEdit: (id: string) => void;
    onDelete: (id: string) => void;
 }
const mapDispatchProps = (dispatch: Dispatch): IDispatchProps => ({
    naviagations: mapNavigationsToProps(dispatch),
    onLoadData: (id: string) => dispatch(RootActionCreators.Outreach.outreachItem.FetchData(id)),
    onEdit: (id: string) => dispatch(RootActionCreators.Navigate.ToOutreachEdit(id)),
    onDelete: (id: string) => dispatch(RootActionCreators.Outreach.outreachItem.DeleteData(id)),
});

// Actual Component
export type AllProps = IProps & IDispatch & IStateProps & IDispatchProps & IPropsFromParams;
export const OutreachDetails = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tOutreach } = useTranslation('outreach');
    const { t: tCommon } = useTranslation('common');

    const loadData = () => props.onLoadData(props.match.params.id);

    React.useEffect(() => {
        const id = props.match.params.id;
        if (props.details.state === FetchState.NotFetched || (props.details.state === FetchState.Success && props.details.data.id !== id)) {
            props.onLoadData(id);
        }
    }, [props.match.params.id, props.details.state, props.details.data.id]);

    const loading = props.details.state !== FetchState.Success;

    return <OutreachNavigation navigations={props.naviagations} >
        <PageHeader
                title="Outreach"
                subTitle="Outreach Detail"
                explainText="Hieronder vind je een lijst van al jouw outreach activiteiten die je hebt geregistreerd. Druk op het menu onderaan deze pagina om de volledige lijst te zien, of een nieuwe registratie uit te voeren."
            />
        <OutreachDetail
          data={props.details.data}
          loading={loading}
          actions={<>
                <RefreshButton onClick={loadData} disabled={props.details.state === FetchState.Busy} />
                <EditButton onClick={() => props.onEdit(props.details.data.id)} disabled={loading || props.details.data.locked} />
                <DeleteButton onClick={() => props.onDelete(props.details.data.id)} disabled={loading || props.details.data.locked}  deleteWarningMessage={tOutreach('outreachDeleteWarning', {...props.details.data, datum: props.details.data.datum.toLocaleDateString()})} />
            </>}
          />
        {props.details.state === FetchState.Error && <ErrorMessage errorDetails={props.details.errorMessage} message={tCommon('errorLoadingData')} title={tCommon('errorLoadingDataTitle')} options={[{optionLabel: tCommon('tryAgain'), optionExecute: loadData},{optionLabel: tCommon('restart'), optionExecute: () => window.location.reload()}]} />}
    </OutreachNavigation>;
};

export default connect<IStateProps, IDispatchProps, {}, IApplicationState>(mapStateProps, mapDispatchProps)(OutreachDetails);